// Validação de datas operacionais (cirurgia, mapa, competência).
// Regra do usuário: bloquear datas com mais de 1 mês de diferença da data
// atual, exceto com confirmação explícita.
import { confirm as _asyncConfirm } from "@/lib/confirm";

const ONE_MONTH_DAYS = 31;

function _diffDays(isoDate) {
  if (!isoDate) return null;
  try {
    const d = new Date(isoDate.substring(0, 10) + "T00:00:00");
    const now = new Date();
    now.setHours(0, 0, 0, 0);
    const diffMs = d.getTime() - now.getTime();
    return Math.round(diffMs / (1000 * 60 * 60 * 24));
  } catch {
    return null;
  }
}

function _fmtBr(iso) {
  if (!iso) return "—";
  try {
    const [y, m, d] = iso.substring(0, 10).split("-");
    return `${d}/${m}/${y}`;
  } catch {
    return iso;
  }
}

/**
 * Returns true if the date is OK or the user confirmed; false if user cancelled.
 * Pass `label` for context-specific messages (ex: "data da cirurgia").
 * Async because it shows the shadcn confirm dialog (Promise-based).
 */
export async function confirmIfFarDate(isoDate, label = "data") {
  if (!isoDate) return true;
  const diff = _diffDays(isoDate);
  if (diff === null) return true;
  // Allow up to 31 days in the past or future without prompting
  if (Math.abs(diff) <= ONE_MONTH_DAYS) return true;
  const direction = diff > 0 ? "no futuro" : "no passado";
  const days = Math.abs(diff);
  const months = Math.round(days / 30);
  return _asyncConfirm({
    title: "Data fora do intervalo usual",
    description:
      `Atenção: a ${label} ${_fmtBr(isoDate)} está ${days} dia(s) ${direction} ` +
      `(aprox. ${months} mês(es)) em relação a hoje.\n\n` +
      `Tem certeza que está correto? Confirme apenas se a data foi digitada de propósito.`,
    confirmText: "Sim, está correto",
    cancelText: "Cancelar",
  });
}

/** Returns true if date is suspect (>1 month off). For UI badges/highlights. */
export function isFarDate(isoDate) {
  if (!isoDate) return false;
  const diff = _diffDays(isoDate);
  return diff !== null && Math.abs(diff) > ONE_MONTH_DAYS;
}

/**
 * Same logic but for YYYY-MM competence strings (used in Faturamento remap).
 * Returns true to proceed, false if user cancelled.
 */
export async function confirmIfFarCompetence(competence, label = "competência") {
  if (!competence || !/^\d{4}-\d{2}$/.test(competence)) return true;
  // Convert to mid-month date and reuse the same checker
  return confirmIfFarDate(`${competence}-15`, label);
}
